import { z } from 'zod';
import { uuid } from './common.js';
export const loginRequest = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1).max(200),
    totp: z.string().trim().regex(/^\d{6}$/).optional(),
});
export const loginResponse = z.discriminatedUnion('status', [
    z.object({ status: z.literal('ok') }),
    z.object({ status: z.literal('totp_required') }),
]);
export const meResponse = z.object({
    user: z.object({
        id: uuid,
        email: z.string(),
        name: z.string(),
        locale: z.enum(['da', 'en']),
        roles: z.array(z.string()),
        capabilities: z.array(z.string()),
        warehouseScope: z.array(uuid).nullable(),
        totpEnabled: z.boolean(),
    }),
});
export const totpSetupResponse = z.object({
    secret: z.string(),
    otpauthUrl: z.string(),
});
export const totpConfirmRequest = z.object({
    code: z.string().trim().regex(/^\d{6}$/),
});
export const changePasswordRequest = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(12).max(200),
});
//# sourceMappingURL=auth.js.map